import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 12.696 4.696 20 4 19.304 11.304 12 4 4.696 4.696 4 12 11.304 19.304 4l.696.696L12.696 12 20 19.304l-.696.696z" />
  </svg>
);
export default SvgClose;
